/*
  ╔══════════════════════════════════════════════════════════════════════════╗
  ║  CONSENT COPY — FOR LEGAL TO REPLACE                                     ║
  ╚══════════════════════════════════════════════════════════════════════════╝

  Every word the site shows when it asks for the marketing/advertising choice
  is in this file, and nothing in this file is anything but words. Replace the
  strings; the consent store and the Meta gate keep working untouched.

  Nothing on the site currently asks the question: the checkbox that did lived
  in the Join the Waitlist dialog, which has been retired, and there is no
  consent banner. CONSENT_NOTICE is what remains of that banner's copy — its
  reopenLabel is still used by the footer's withdrawal control.

  ── Status of this text ────────────────────────────────────────────────────
  NOT legally approved. It is deliberately plain and makes no claim about
  compliance, certification or adequacy: it says what the technologies are for
  and offers a choice, and that is all. The repository contains no approved
  consent or cookie wording — the Privacy Policy's §19 ("Cookies and Website
  Technologies") says only that "appropriate notices or consent mechanisms will
  be provided" and does not yet mention Meta, advertising or retargeting, which
  is the disclosure Legal has said it is drafting.

  So this copy is a placeholder that behaves correctly, not a substitute for
  that drafting.

  ── Rules for whoever edits it ─────────────────────────────────────────────
  - Do not claim the site or the company is "DPDP compliant" here. A compliance
    claim is not a consent notice, and this component cannot make one true.
  - Keep "reject" wording as plain and as short as the "accept" wording. The
    two controls are rendered with the same size, the same weight and the same
    prominence on purpose; copy that makes one sound like the safe, obvious or
    recommended choice undoes that.
  - Name the purposes the tracking actually serves. Today those are advertising
    measurement and audience/retargeting for the waitlist campaign, via Meta
    Pixel and Meta's Conversions API. If that changes, this text changes.
  - The Cookie Policy link stays absent until there is a real Cookie Policy to
    link to. The banner shows it automatically once one is configured; a link
    to a page that does not exist is worse than no link.
*/

/*
  ── Cookie Policy link ─────────────────────────────────────────────────────
  THERE IS NO COOKIE POLICY PAGE IN THIS REPOSITORY.

  src/App.js routes "/privacy" and "/terms" and nothing else legal; src/legal/
  holds privacyContent.js and termsContent.js and no cookie document. Legal has
  to write and approve that content — this file will not invent it, and the
  banner will not link to a page that does not exist.

  So the link is configuration, resolved in this order:

    1. REACT_APP_COOKIE_POLICY_PATH, if set at build time. Lets DevOps turn the
       link on without a code change once Legal has somewhere to point it:
         - an in-site route, e.g. "/cookies", is rendered as a client-side link;
         - an absolute "https://…" URL is rendered as an external link, for a
           policy that lives on another host or as a hosted document.
    2. Otherwise COOKIE_POLICY_FALLBACK below — edit this when the route ships
       and is part of the app.
    3. Otherwise null, and the banner shows only the Privacy Policy link.

  An in-site path must have a real <Route> in App.js, and an entry in
  scripts/generate-static-routes.js if it has to survive a direct hit. Pointing
  this at a path with no route sends the visitor to the catch-all redirect.
*/
const COOKIE_POLICY_FALLBACK = null;

const configuredCookiePolicy = (process.env.REACT_APP_COOKIE_POLICY_PATH || "").trim();

export const COOKIE_POLICY_PATH = configuredCookiePolicy || COOKIE_POLICY_FALLBACK;

export const PRIVACY_POLICY_PATH = "/privacy";

export const CONSENT_NOTICE = {
  /* Short, and not a question — the buttons ask the question. Rendered inline
     as the lead-in to the sentence below, so it costs no extra line. */
  title: "Cookies on this site",

  /* One sentence. It names the purposes and the technologies and nothing else;
     the reassurance and the link follow in their own short sentences so any of
     the three can be replaced on its own. */
  body:
    "We use cookies and similar technologies to operate the site and, with " +
    "your permission, measure advertising performance and support " +
    "personalized advertising, including Meta Pixel and Conversions API.",

  /* Shown after the body, in the same paragraph. Kept separate so Legal can
     drop it without touching the sentence above. */
  detail: "Rejecting does not affect your use of the site.",

  /* "See our [Privacy Policy] for more information." — split around the link
     so the link text stays a single string with its own label below. */
  policyPrefix: "See our ",
  policySuffix: " for more information.",

  acceptLabel: "Accept marketing cookies",
  rejectLabel: "Reject marketing cookies",

  /* For the footer control that reopens the banner. */
  reopenLabel: "Cookie Settings",

  privacyLinkLabel: "Privacy Policy",
  cookieLinkLabel: "Cookie Policy",
};
